import * as THREE from 'three'

export const getSeatMaterial = (
  { color, opacity = 1, options = {} },
  materials
) => {
  const id = `${color}:${opacity}:${JSON.stringify(options)}`
  if (!materials.seat[id]) {
    materials.seat[id] = new THREE.MeshBasicMaterial({
      color,
      opacity,
      transparent: opacity !== 1,
      ...options
    })
  }
  return materials.seat[id]
}
